import React, { Fragment, useEffect, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectDivisionsDrillDown,
  makeSelectDimensions,
  makeSelectIsLoadingDivisions,
  makeSelectMetric,
} from "./selectors"
import { getDivisionsWatcher } from "./actions"

import {
  isAdmin,
  isAdminMandu,
  isAmbassadorActive,
  isModeInModuleBySlug,
  KEY_CHECKBOX_EXCLUDE,
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
  setItem,
} from "../../../utils/storage"
import { validate } from "../../../utils/functions"
import empty_meditions from "../../../images/emptyDivisions.svg"
import {
  Checkbox,
  Empty,
  Popover,
  Select,
  Spin,
  Tooltip,
  TreeSelect,
} from "antd"
import { Link } from "react-router-dom"
import { QuestionCircleFilled } from "@ant-design/icons"
import {
  DISABLE,
  RESULT_BY_DIMENSION,
  RESULT_BY_DIVISION,
  WORKING_ENVIRONMENT_LABEL,
} from "../../../utils/constants"
import { get } from "lodash"
import { generateTree } from "../../../utils/utils"
import BarChartDivisionNotHistory from "../../../components/Recharts/BarChartDivisionNotHistory"
import { PageView } from "../../../components/Snowplow/config2"

import "../../../Reports/components/EngagementMeasurement/components/WidgetResultByDivisionEngagement/index.less"

const { TreeNode } = TreeSelect
const { Option } = Select

export function WidgetResultByDivisionEngagement(props) {
  const divisionID = props.idDivisionSelected
  const [isEngagement, setIsEngagement] = useState(true)
  const [checkboxExclude, setCheckboxExclude] = useState(
    LOCAL_CHECKBOX_EXCLUDE() == "true"
  )
  const [selectedFilter, setSelectedFilter] = useState(undefined)
  const [selectedType, setSelectedType] = useState("Engagement")

  useEffect(() => {
    setIsEngagement(true)
    setSelectedFilter(undefined)
    setSelectedType("Engagement")
    setCheckboxExclude(LOCAL_CHECKBOX_EXCLUDE() == "true")
    initGetData()
  }, [props.idMeasure, props.idDivisionSelected, props.selectedSegment])

  const initGetData = () => {
    const {
      idMeasure,
      getDivisions,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props

    if (!validate.exist(measureGeneral)) return

    const params = {
      isHome: true,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      id_segment: selectedSegment,
      history,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() == "true" &&
        LOCAL_ISOLATED_METRICS() == "true",
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    }
    if (measureGeneral.is_engagement) {
      params.dimensionType = "Engagement"
      params.is_engagement = true
    } else {
      params.is_engagement = false
    }

    getDivisions(params)
  }

  const changeDimension = (value, exclude = false) => {
    const { measureGeneral, idMeasure, getDivisions, selectedSegment } = props
    const params = {
      dimension: value,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      isExclude: exclude,
      id_segment: selectedSegment,
      params: { id_division: divisionID, id_segment: selectedSegment },
    }
    if (measureGeneral.is_engagement && selectedType === "Engagement") {
      params.dimensionType = "Engagement"
      params.is_engagement = true
    } else {
      params.is_engagement = false
    }
    getDivisions(params)
  }

  const changeDimensionType = (value, exclude = false) => {
    const { measureGeneral, idMeasure, getDivisions, selectedSegment } = props
    setIsEngagement(value === "Engagement")
    getDivisions({
      dimension: null,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      is_engagement: true,
      isExclude: exclude,
      dimensionType: value,
      id_segment: selectedSegment,
      params: { id_division: divisionID, id_segment: selectedSegment },
    })
  }

  const isAmbassador = isAmbassadorActive()
    ? validate.exist(divisionID)
      ? `&id_division=${divisionID}`
      : `&id_division=${props.idDivisionParent}`
    : ""

  const newDimensions = props.dimensions?.data
    ? props.dimensions.data.filter((e) => {
        if (
          props.measureGeneral.is_engagement &&
          selectedType == "Engagement"
        ) {
          if (e.engagement) return e
        } else if (!e.engagement) return e
      })
    : []

  const headerDimension = () => {
    const { metric, idMeasure, measureGeneral, selectedSegment } = props
    let isRedirect = false
    if (!metric) {
      isRedirect = isModeInModuleBySlug(RESULT_BY_DIMENSION)
    } else {
      isRedirect = isModeInModuleBySlug(RESULT_BY_DIVISION)
    }
    let newDimensionsAux = [...newDimensions]
    newDimensionsAux = generateTree(
      "id",
      "id_parent",
      newDimensionsAux,
      "childs",
      false
    )
    if (newDimensionsAux.length > 0 && selectedType == "Engagement") {
      newDimensionsAux = newDimensionsAux[0].childs
    }

    let querySegment = ""
    let queryDivision = ""
    let queryParams = ""

    if (isAmbassador !== "") {
      queryDivision = isAmbassador
    }

    if (measureGeneral.segments.length > 1 && selectedSegment) {
      querySegment = `&id_segment=${selectedSegment}`
    }

    if (queryDivision !== "" || querySegment !== "") {
      queryParams = `${"?home=true"}${queryDivision}${querySegment}`
    }

    if ((isAdmin() || isAdminMandu()) && validate.exist(divisionID)) {
      queryParams = `?home=true&id_division=${divisionID}`
    }

    return (
      <div className="WidgetResultByDivisionEngagement-Header">
        <div className="WidgetResultByDivisionEngagement-Header-Title">
          <span>Resultado por división</span>
          {isRedirect !== DISABLE && (
            <div className="WidgetResultByDivisionEngagement-Header-Link">
              <span>
                <Link
                  onClick={() =>
                    PageView(
                      "Resultado por división - Ir a ranking de divisiones",
                      null,
                      null
                    )
                  }
                  to={`/reports/measure/${idMeasure}/divisions${queryParams}`}
                >
                  {"Ir a ranking de divisiones >"}
                </Link>
              </span>
            </div>
          )}
        </div>
        <div className="WidgetResultByDivisionEngagement-Header-Filters">
          {renderExcludeDivision()}
          <div className="">
            <TreeSelect
              style={{ width: 200 }}
              placeholder={
                props.measureGeneral.is_engagement && isEngagement
                  ? "Seleccionar outcome"
                  : "Seleccionar dimensión"
              }
              showSearch
              allowClear
              value={selectedFilter}
              treeNodeFilterProp="title"
              onChange={(s, c, extra) => onChangeSelectedFilter(s, extra)}
            >
              {newDimensionsAux.map((e) => {
                return (
                  <TreeNode
                    idSelected={e.id}
                    value={e.id}
                    title={e.name}
                    key={e.id}
                  >
                    {e.childs &&
                      e.childs.map((child) => {
                        return (
                          <TreeNode
                            value={child.id}
                            key={child.id}
                            idSelected={child.id}
                            title={
                              <Tooltip title={child.name}>{child.name}</Tooltip>
                            }
                          />
                        )
                      })}
                  </TreeNode>
                )
              })}
            </TreeSelect>

            {!props.measureEngagement?.engagement_is_only && (
              <Select
                placeholder="Seleccionar"
                value={selectedType}
                onChange={(s) => onChangeSelectedType(s)}
                style={{ width: 200, marginLeft: 16 }}
              >
                {["Engagement", setNameMetricsTotalLabel()].map((f, i) => (
                  <Option key={i} value={f}>
                    {f}
                  </Option>
                ))}
              </Select>
            )}
          </div>
        </div>
      </div>
    )
  }

  const onChangeSelectedFilter = (s, extra) => {
    setSelectedFilter(s)
    changeDimension(
      extra.triggerNode && extra.triggerNode.props
        ? extra.triggerNode.props.idSelected
        : undefined,
      checkboxExclude
    )
  }

  const onChangeSelectedType = (value) => {
    setSelectedType(value)
    setSelectedFilter(null)
    changeDimensionType(value, checkboxExclude)
  }

  const changeExcludeCheckbox = (checked) => {
    setItem(KEY_CHECKBOX_EXCLUDE, checked)
    setCheckboxExclude(checked)
    changeDimension(selectedFilter, checked)
  }

  const renderExcludeDivision = () => {
    if (LOCAL_ISOLATED_METRICS() != "true") {
      return null
    }
    return (
      <div
        style={{
          marginLeft: "auto",
          paddingRight: 20,
          height: 30,
          paddingTop: 5,
        }}
      >
        <Checkbox
          checked={checkboxExclude}
          onChange={(e) => changeExcludeCheckbox(e.target.checked)}
        >
          Excluir subdivisiones
        </Checkbox>
        <Popover
          placement="top"
          content={
            <div style={{ maxWidth: 245, textAlign: "center" }}>
              Activa el checkbox para visualizar los
              <br />
              resultados únicamente de las
              <br />
              divisiones superiores, <b>excluyendo</b> los
              <br />
              resultados de sus subdivisiones.
            </div>
          }
        >
          <QuestionCircleFilled
            style={{
              color: "#D8D8D8",
              verticalAlign: "baseline",
              fontSize: "12px",
            }}
          />
        </Popover>
      </div>
    )
  }

  const setNameMetricsTotalLabel = () => {
    const { measureGeneral } = props
    let response = get(measureGeneral, "survey_type_name", null)
    return response
  }

  if (!props.isLoadingDivisions && props.divisionsDrillDown.length === 0) {
    return (
      <div className="WidgetResultByDivisionEngagement">
        <Empty
          style={{ color: "#828282" }}
          image={empty_meditions}
          description="¡Aún no se cuenta con un resultado a nivel de cada división!"
          className="ReportsHome-empty-fix"
        />
      </div>
    )
  }

  const chartDivision = () => {
    if (props.isLoadingDivisions) {
      return (
        <Fragment>
          <div className="WidgetResultByDivisionEngagement-Chart loadingSpin">
            <Spin size="large" />
          </div>
        </Fragment>
      )
    }
    return (
      <div className="WidgetResultByDivisionEngagement-Chart">
        <BarChartDivisionNotHistory
          legendVerticalAlign="bottom"
          legendMargin={{}}
          metric={props.metric}
          divisionsDrillDown={props.divisionsDrillDown}
          calculationType={props.measureGeneral.id_survey_calculation_type}
        />
      </div>
    )
  }

  return (
    <div className="WidgetResultByDivisionEngagement">
      {headerDimension()}
      {chartDivision()}
    </div>
  )
}

WidgetResultByDivisionEngagement.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureEngagement: PropTypes.object,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoadingDivisions: PropTypes.bool,
  divisionsDrillDown: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  metric: PropTypes.object,
  getDivisions: PropTypes.func,
  selectedSegment: PropTypes.number,
  dimensions: PropTypes.object,
}

const mapStateToProps = createStructuredSelector({
  isLoadingDivisions: makeSelectIsLoadingDivisions(),
  divisionsDrillDown: makeSelectDivisionsDrillDown(),
  metric: makeSelectMetric(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDivisions: (params) => dispatch(getDivisionsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({
  key: "widgetResultByDivisionEngagementV2",
  reducer,
})
const withSaga = injectSaga({
  key: "widgetResultByDivisionEngagementV2",
  saga,
})

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetResultByDivisionEngagement)
